import {createSlice} from '@reduxjs/toolkit'

const initialState = {
  countryCode: localStorage.getItem('countryCode') || '', // Get countryCode from localStorage
}

const countryCodeSlice = createSlice({
  name: 'countryCode',
  initialState,
  reducers: {
    setCountryCode(state, action) {
      state.countryCode = action.payload
      localStorage.setItem('countryCode', state.countryCode) // Save countryCode to localStorage
    },
  },
})

export const {setCountryCode} = countryCodeSlice.actions

export const selectCountryCode = state => state.countryCode?.countryCode // Selector for countryCode

export default countryCodeSlice.reducer
